// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  --background: var(--ion-color-light-warm);
}
ion-header ion-toolbar ion-title {
  font-size: 1rem;
  font-weight: 500;
  left: 0;
  position: absolute;
  top: 0;
}

.param-toolbar {
  padding: 0 1rem;
}
.param-toolbar .title ion-text {
  font-weight: bold;
}
.param-toolbar .params-grid {
  padding: 0;
}
.param-toolbar .params-grid-row {
  align-items: center;
}
.param-toolbar .params-grid-row ion-col {
  padding: 2px;
}
.param-toolbar .params-grid-row ion-col ion-input {
  --padding-top: 5px;
  --padding-bottom: 2px;
  background: #fff;
  border: 1px solid #000;
  margin-left: 10px;
}
.param-toolbar .params-grid-row ion-col.help-button-col {
  text-align: right;
}
.param-toolbar .params-grid-row ion-col.help-button-col .help-button {
  --min-height: 30px;
  --padding-end: 0;
  height: 30px;
  margin: -2px;
}
.param-toolbar .params-grid-row ion-col.help-button-col .help-button-icon {
  height: 30px;
  width: 30px;
}

.searchbar {
  height: 50px !important;
}

ion-content {
  --background: var(--ion-color-light-warm);
}

.cars-list ion-item {
  --background: var(--ion-color-light-warm);
  --background-hover: var(--ion-color-light-warm);
  --background-activated: var(--ion-color-light-warm);
  --padding-start: 1rem;
}
.cars-list ion-item:first-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.cars-list ion-item ion-checkbox {
  margin-right: 0;
}

ion-footer {
  --background: var(--ion-color-light-warm);
}
ion-footer ion-toolbar {
  --background: var(--ion-color-light-warm);
  border-top: 1px solid rgba(0, 0, 0, 0.07);
}
ion-footer ion-toolbar .submit-button {
  --opacity: 1;
  --background-hover: var(--ion-color-primary);
  --background-activated: var(--ion-color-primary);
  --background-focused: var(--ion-color-primary);
  --background: var(--ion-color-primary);
  --color: var(--ion-color-light);
  margin: 10px 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
